import React from "react";
import Card from "./Cardcongif"



const Cards = () => {
  return (

            <Card/>               
  
  );
};

export default Cards